import { ACTIONS } from '../const';
import { httpGET, httpPOST, json } from './utils.js';

export const getCSRF = () => dispatch => {
    return httpGET('/api/csrftoken/')
        .then(json)
        .then(response => {
            dispatch({
                type: ACTIONS.SYNC_CSRF,
                token: response.csrfmiddlewaretoken,
            });
        });
};

// This is an internal action creator. No need to export it
const preloadPreferences = user => dispatch => {
    return httpGET(user.preferences)
        .then(json)
        .then(preferences => {
            dispatch({
                type: ACTIONS.SYNC_PREFERENCES,
                preferences,
            });
        });
};

// This is an internal action creator. No need to export it
const loginSetup = user => dispatch => {
    const preferences = dispatch(preloadPreferences(user));
    const csrf = dispatch(getCSRF());

    // csrf needs to be reloaded after a login
    return Promise.all([preferences, csrf]).then(() => {
        dispatch({
            type: ACTIONS.SYNC_USER,
            user: user,
        });
    });
};

export const login = (username, password) => dispatch => {
    return httpPOST('/api/v4/user/login/', { username, password })
        .then(json)
        .then(user => {
            if (user.error) {
                throw new Error(user.error);
            }

            try {
                return dispatch(loginSetup(user));
            } catch (e) {
                setTimeout(() => {
                    throw e;
                }, 0);
            }
        });
};

export const getUser = () => dispatch => {
    return httpGET('/api/v4/user/login/')
        .then(json)
        .then(user => {
            if (user.error) return;

            try {
                return dispatch(loginSetup(user));
            } catch (e) {
                setTimeout(() => {
                    throw e;
                }, 0);
            }
        });
};

export const signEula = () => () => {
    return httpPOST('/api/v3/eula/', {}).then(
        () => (window.location.href = '/')
    );
};



// WEBPACK FOOTER //
// ./src/actions/login.js